import { Box, Button, Tooltip } from "@mui/material";
import React, { useCallback, useMemo } from "react";
import ObjectInfoTooltip from "../../../data/ObjectInfoTooltip";
import { useDispatch } from "react-redux";
import { AttachFileOutlined } from "@mui/icons-material";
import { sidebarSetValues } from "../../../../redux/actions/sidebarActions";
import { isNil } from "lodash";

const PreviewableLoanFileButton = ({
  text,
  // startIcon = (
  //   <VisibilityOutlined className="thin" sx={{ transform: "rotate(180deg)" }} />
  // ),
  startIcon = (
    <AttachFileOutlined className="thin" sx={{ transform: "rotate(180deg)" }} />
  ),
  file,
  onClick,
  iconSize = 14,
  fontSize = 11,
  maxWidth = "270px",
  sx,
}) => {
  const dispatch = useDispatch();

  const onPreviewClick = useCallback(() => {
    if (onClick) {
      onClick(file);
    }
    if (!file) {
      return;
    }
    dispatch(
      sidebarSetValues({
        type: "filePreview",
        state: file,
      })
    );
  }, [dispatch, file, onClick]);

  const styles = useMemo(() => {
    return {
      py: 0.5,
      px: 0.5,
      fontWeight: 400,
      border: "1px solid #e3f2fd",
      /* REQUIRED for ellipsis */
      maxWidth, // adjust as needed
      minWidth: 0,
      justifyContent: "flex-start",

      fontSize: "12px !important",

      ".MuiButton-startIcon": {
        mr: "1px",
        flexShrink: 0, // prevent icon from shrinking
      },

      ".MuiSvgIcon-root": {
        fontSize: `${iconSize}px !important`,
        // fontSize: "14px !important",
      },

      ...sx,
    };
  }, [sx, maxWidth, iconSize]);

  const buttonContent = (
    <Button
      onClick={onPreviewClick}
      variant="text"
      size="small"
      sx={styles}
      startIcon={startIcon}
    >
      <span
        style={{
          fontSize,
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap",
          display: "block",
          minWidth: 0,
          textAlign: "left",
          flexGrow: 1,
        }}
      >
        {text || file?.file_display_name}
      </span>
    </Button>
  );

  if (isNil(file)) {
    return (
      <Tooltip
        title={
          <>
            No File Uploaded. <b>Click to upload.</b>
          </>
        }
        placement="right"
      >
        <Box sx={{ flexGrow: 0, width: "max-content" }}>{buttonContent}</Box>
      </Tooltip>
    );
  }

  return (
    <ObjectInfoTooltip
      title={file?.file_display_name || "File Details"}
      placement="right"
      returnEmptyChildWhenMissingData
      format={[
        { field: "modifiedDate", type: "date" },
        { field: "uploadDate", type: "date" },
        { field: "reportEffectiveDate", type: "date" },
      ]}
      data={file}
      excludeKeys={[
        "_id",
        "content_type",
        "container_type",
        "dealId",
        "file_storage_name",
        "containerName",
      ]}
    >
      {buttonContent}
    </ObjectInfoTooltip>
  );
};

export default PreviewableLoanFileButton;
